
import { DevicePropertyDescription } from "@/api/dtos/Station.schema";
import { deepClone } from "@/misc/helpers";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import EditFrame from "../EditFrame.vue";
import EditActionButtons from "../EditActionButtons.vue";

@Component({
  components: {
    EditFrame,
    EditActionButtons,
  },
})
export default class PropertyDescriptions extends Vue {
  @Prop({ default: [] })
  devicePropertyDescriptions!: DevicePropertyDescription[];

  @Prop()
  width!: number;

  @Prop({
    default: false,
  })
  hideControls!: boolean;

  @Prop({
    default: false,
  })
  readonly forceEditing!: boolean;

  editedDevicePropertyDescriptions: DevicePropertyDescription[] = [];
  selectedDevicePropertyDescription: DevicePropertyDescription | null = null;

  formValidated = false;

  mounted(): void {
    this.importData();

    if (this.forceEditing) {
      this.isEditing = true;
    }
  }

  @Watch("devicePropertyDescriptions")
  onDescriptionsChanged(): void {
    this.importData();
  }

  importData(): void {
    this.editedDevicePropertyDescriptions = deepClone(
      this.devicePropertyDescriptions
    );
    this.selectedDevicePropertyDescription =
      this.editedDevicePropertyDescriptions[0];
    if (this.editedDevicePropertyDescriptions.length === 0) {
      this.formValidated = true;
    }
  }

  get devicePropertySelectItems(): {
    text: string;
    value: DevicePropertyDescription;
  }[] {
    return this.editedDevicePropertyDescriptions.map(
      (devicePropertyDescription) => {
        return {
          text: devicePropertyDescription.property,
          value: devicePropertyDescription,
        };
      }
    );
  }
  $refs!: {
    editFrame: EditFrame;
  };
  isEditing = false;
  onSave(): void {
    this.$emit("save", this.selectedDevicePropertyDescription);
  }

  onSaveAll(): void {
    this.$emit("save", this.editedDevicePropertyDescriptions);
  }

  onValidChanged(value: boolean): void {
    this.$emit("valid", value);
    this.formValidated = value;
  }

  onCancel(): void {
    this.importData();
  }

  tryValidate(): boolean {
    if (this.formValidated) {
      this.onSaveAll();
      return true;
    }
    return false;
  }
}
